/**
 * `dev/sessionPorts.ts`'s offsets of the simulated devices in a checkout's port
 * block — the templates (`studioTemplate.ts`) put the devices there. Its own
 * file with no imports, so a loader that cannot resolve workspace subpaths
 * (Playwright's, for `apps/web/tests/e2e-playout/stack.ts`) can still read it.
 */
export const SIM_PORT_OFFSETS = { mixer: 5, video: 6, graphics: 7 } as const;
